import { defineStore } from "pinia";
import { useAdditionalServiceField } from "@/features/experience-curation/lib/useAdditionalServiceField";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";

export const useCurationDuration = defineStore("curation-content-duration-field", () => {
  const field = useAdditionalServiceField({
    id: "duration",
    functionalGroupCode: "DURATION",
  });
  const hasUnpublishedChange = useHasFunctionalFieldChange("duration");

  const isRequired = true;

  return { ...field, isRequired, hasUnpublishedChange };
});
